export default __webpack_public_path__ + "static/media/noDeck.24bfaec1.svg";